var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiGeneration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11341_19375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1934 5H11.3006V10.6937H10.1934V5Z",
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79894 9.52326H5.83421L5.46514 10.6937H4.30005L6.20327 5H7.46244L9.35119 10.6937H8.14268L7.79894 9.52326ZM7.48776 8.54213L6.822 6.30174L6.13452 8.54213H7.48776Z",
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8C13.75 11.1756 11.1756 13.75 8 13.75V15.25C12.0041 15.25 15.25 12.0041 15.25 8H13.75ZM8 13.75C4.82436 13.75 2.25 11.1756 2.25 8H0.75C0.75 12.0041 3.99594 15.25 8 15.25V13.75ZM2.25 8C2.25 4.82436 4.82436 2.25 8 2.25V0.75C3.99594 0.75 0.75 3.99594 0.75 8H2.25ZM8 2.25C11.1756 2.25 13.75 4.82436 13.75 8H15.25C15.25 3.99594 12.0041 0.75 8 0.75V2.25Z",
    fill: "#2E3438"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11341_19375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGeneration);
export default __webpack_public_path__ + "static/media/aiGeneration.a046e9fbd5f02b8d1d5624dfda61c29f.svg";
export { ForwardRef as ReactComponent };